import debugWallet from './debugWallet.js';
import buildStorageValues from './buildStorageValues.js';
async function updateWalletStorage(_ref) {
  let {
    walletStorageService,
    currentPaymentsInfo = {},
    payload = {},
    shouldSetLastUpdated = false,
    actionCode = ''
  } = _ref;
  if (walletStorageService) {
    const newPaymentsInfo = {
      ...currentPaymentsInfo,
      ...payload,
      tradeIn: {
        ...currentPaymentsInfo.tradeIn,
        ...payload.tradeIn
      },
      creditVerification: {
        ...currentPaymentsInfo.creditVerification,
        ...payload.creditVerification
      },
      interactions: {
        ...currentPaymentsInfo.interactions,
        ...payload.interactions
      }
    };
    if (actionCode && payload?.listingId) {
      // Update interaction values if a valid actionCode was passed in
      if (actionCode === 'addHideReceiptListing') {
        if (!currentPaymentsInfo?.interactions?.hideReceipt) {
          newPaymentsInfo.interactions.hideReceipt = [payload.listingId]; // payload is a listing id
        } else {
          newPaymentsInfo.interactions.hideReceipt = [...currentPaymentsInfo.interactions.hideReceipt, payload.listingId];
        }
      } else if (actionCode === 'removeHideReceiptListing') {
        if (!currentPaymentsInfo?.interactions?.hideReceipt) {
          newPaymentsInfo.interactions = {
            ...currentPaymentsInfo?.interactions,
            hideReceipt: []
          };
        } else {
          newPaymentsInfo.interactions = {
            ...currentPaymentsInfo?.interactions,
            hideReceipt: [...currentPaymentsInfo.interactions.hideReceipt.filter(item => item !== payload.listingId)]
          };
        }
      }
    }
    if (shouldSetLastUpdated) {
      newPaymentsInfo.lastUpdated = Date.now();
    }
    const options = {
      paymentsInfo: buildStorageValues({
        payload: {
          ...newPaymentsInfo
        }
      })
    };
    debugWallet('Update Wallet Storage:', options);
    const response = await walletStorageService.updateData(options);
    return {
      newPaymentsInfo,
      success: response?.success
    };
  }
  return currentPaymentsInfo;
}
export { updateWalletStorage as default };
